"use client"
import React from "react"
import Heading from "../../Atoms/Heading"
import Text from "../../Atoms/Text"
import { useParams, usePathname } from "next/navigation"
import { t } from "@/translations"
import { getLangCode } from "@/app/(site)/_utils/misc"

type CheckoutStep = "information" | "shipping" | "payment"

export const StepNavigation = () => {
    let currentStep = useParams().step as CheckoutStep
    const langCode = getLangCode(usePathname().split("/")[1]) ?? ""
    if (!currentStep) {
        currentStep = "information"
    }

    const stepClasses = (step: CheckoutStep) => {
        return `border-b pt-8 pb-16 ${currentStep === step ? "text-bold border-black" : ""}`
    }

    return (
        <div className="mb-48">
            <Heading type="h1" className="mb-32 hidden md:block">
                {t(langCode, currentStep.charAt(0).toUpperCase() + currentStep.slice(1))}
            </Heading>
            <div className="grid grid-cols-3 gap-8 md:gap-16">
                <div className={stepClasses("information")}>
                    <Text
                        weight="regular"
                        size="medium"
                        className="flex justify-center !text-12"
                    >
                        1. {t(langCode, "Information")}
                    </Text>
                </div>
                <div className={stepClasses("shipping")}>
                    <Text
                        weight="regular"
                        size="medium"
                        className="flex justify-center !text-12"
                    >
                        2. {t(langCode, "Shipping")}
                    </Text>
                </div>
                <div className={stepClasses("payment")}>
                    <Text
                        weight="regular"
                        size="medium"
                        className="flex justify-center !text-12"
                    >
                        3. {t(langCode, "Payment")}
                    </Text>
                </div>
            </div>
        </div>
    )
}
